import { api } from '@src/constants/api';
import { createMiddleware, Next, regularThenResponse, regularErrorHandling, regularThenResponseError } from '@src/utils';
import { packagesActions } from '@src/store/reducers/packagesReducer';
import { scriptsActions } from '@src/store/reducers/scriptsReducer';

export const createPackagesMiddleware = (http: any, successPopUp: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [packagesActions.GET_SCRIPTS]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}projects/${action.payload.id}/ScanAndGetImportedScripts`);
                return regularThenResponse(response, action, (response: any) => {
                    const data = { scripts: response.data.scripts, scriptImportErrors: response.data.errorMessages };
                    next({ type: packagesActions.SET_SCRIPTS, payload: data });
                });
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [packagesActions.DELETE_SCRIPTS_WITHOUT_PACAKGE]: async (action: any) => {
            try {
                const payload = action.payload;
                const response = await http.delete(`${restServiceUrl}projects/${payload.projectId}/scripts/${payload.scriptId}`);
                return regularThenResponse(response, action);
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [packagesActions.UPLOAD_PACKAGE_SCRIPT]: async ({ payload }: any) => {
            const upload = payload.uploadObject;
            const url = `${restServiceUrl}Projects/${payload.projectId}/Schema/${payload.schemaId}`;
            const file = upload.upload({ url, data: { file: payload.file } }).then(
                (response: any) => { payload.onResult(response); },
                (response: any) => { payload.onErrorResult(response); },
                (evt: any) => { payload.onProgress(evt); });
            return file;
        },
        [packagesActions.UPDATE_PACKAGE_SCRIPT]: async (action: any, next: Next, state: any) => {
            try {
                const response = await http({
                    method: 'put',
                    url: `${restServiceUrl}Projects/${action.payload.projectId}/Script`,
                    data: {
                        id: action.payload.scriptId,
                        packageId: action.payload.packageId || 0,
                        script: action.payload.content
                    }
                });
                if (response.data) {
                    successPopUp();
                    next({ type: packagesActions.UPDATE_PACKAGE_SCRIPT, payload: {} });
                    state.dispatch({
                        type: scriptsActions.GET_SCRIPT_DATA,
                        payload: {
                            projectId: action.payload.projectId,
                            packageId: action.payload.packageId || 0,
                            scriptId: action.payload.scriptId
                        }
                    });
                    state.dispatch({ type: packagesActions.GET_SCRIPTS, payload: { id: action.payload.projectId } });
                    return response;
                }
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [packagesActions.DELETE_SCRIPT_LIST_WITHOUT_PACAKGE]: async (action: any, _: Next, state: any) => {
            try {
                const response = await http({
                    url: `${restServiceUrl}projects/${action.payload.projectId}/scripts`,
                    method: 'DELETE',
                    data: { ids: action.payload.scriptsIds },
                    headers: { 'Content-Type': 'application/json;charset=utf-8' }
                });
                return regularThenResponse(response, action, (response: any) => {
                    if (response.data) {
                        state.dispatch({ type: packagesActions.GET_SCRIPTS, payload: { id: action.payload.projectId } });
                    }
                });
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [packagesActions.NO_ITEMS_PACKAGES]: async (_: any, next: Next) => {
            next({ type: packagesActions.NO_ITEMS_PACKAGES, payload: { no_items_packages: true } });
        },
        [packagesActions.GET_PACKAGE_INFO]: async (action: any) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Package/${payload.packageId}/PackageWithScriptsAndExclusions`;
                const response = await http.get(url);
                return regularThenResponse(response, action, (response: any) => response);
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [packagesActions.GET_PACKAGES]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}Projects/${action.payload.id}/Packages/All`);
                return regularThenResponse(response, action, (response: any) => {
                    const data = { packages: response.data, no_items_packages: false };
                    next({ type: packagesActions.SET_PACKAGES, payload: data });
                });
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [packagesActions.GET_NEXT_REGULAR_PACKAGE_NAME]: async (action: any, next: Next) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/GetNextRegularPackageName`;
                const response = await http.get(url);
                next({ type: packagesActions.SET_NEXT_REGULAR_PACKAGE_NAME, payload: { nextRegularPackage: response.data } });
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },        
        [packagesActions.GET_PACKAGES_OF_ENV_BUILD]: async (action: any, next: Next) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envID}/Packages/NonAdhoc`;
                const response = await http.get(url);
                next({ type: packagesActions.SET_PACKAGES_OF_ENV, payload: { deployedPackages: response.data } });
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [packagesActions.GET_PACKAGES_OF_ENV]: async (action: any, next: Next) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envID}/Packages`;
                const response = await http.get(url);
                next({ type: packagesActions.SET_PACKAGES_OF_ENV, payload: { deployedPackages: response.data } });
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [packagesActions.GET_PACKAGE_OF_ENV]: async (action: any, next: Next) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envID}/Packages/${payload.packageId}`;
                const response = await http.get(url);
                return regularThenResponse(response, action, (response: any) => {
                    const data = { packages: action.payload.packages, selectedPackage: response.data };
                    next({ type: packagesActions.SET_PACKAGE_OF_ENV, payload: { deployedPackages: data } });
                });
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [packagesActions.GET_PACKAGE_OF_ENV_WITH_JOBID]: async (action: any, next: Next) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envID}/Packages/${payload.packageId}/Job/${payload.jobId}`;
                const response = await http.get(url);
                return regularThenResponse(response, action, (response: any) => {
                    const data = { packages: action.payload.packages, selectedPackage: response.data };
                    next({ type: packagesActions.SET_PACKAGE_OF_ENV_WITH_JOBID, payload: { deployedPackages: data } });
                });
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [packagesActions.ADD_PACKAGE]: async (action: any, _: Next, state: any) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Packages/${payload.packageName}/IsAdHoc/${payload.isAdhocPackage}/Create`;
                const response = await http.post(url, {});
                return regularThenResponse(response, action, () => {
                    state.dispatch({ type: packagesActions.GET_PACKAGES, payload: { id: payload.projectId } });
                });
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [packagesActions.DELETE_PACKAGE]: async (action: any, _: Next, state: any) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Packages/${payload.packageId}`;
                const response = await http.delete(url);
                return regularThenResponse(response, action, () => {
                    state.dispatch({ type: packagesActions.GET_PACKAGES, payload: { id: payload.projectId } });
                });
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [packagesActions.ADD_SCRIPT_TO_PACKAGE]: async (action: any) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Packages/${payload.packageId}/Scripts/${payload.scriptId}`;
                const response = await http.put(url);
                return regularThenResponse(response, action, (response: any) => response);
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [packagesActions.ADD_SCRIPT_TO_PACKAGE_WITH_SCRIPT_TYPE]: async (action: any) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Packages/`
                    + `${payload.packageId}/Scripts/${payload.scriptId}/WithScriptType/${payload.scriptType}`;
                const response = await http.put(url);
                return regularThenResponse(response, action, (response: any) => response);
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [packagesActions.CHANGE_SCRIPT_TYPE]: async (action: any) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Packages/`
                    + `${payload.packageId}/Scripts/${payload.scriptId}/ChangeScriptType/${payload.scriptType}`;
                const response = await http.get(url);
                return regularThenResponse(response, action, (response: any) => response);
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [packagesActions.REMOVE_SCRIPT_TO_PACKAGE]: async (action: any, _: Next, state: any) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Packages/${payload.packageId}/Scripts/${payload.scriptId}`;
                const response = await http.delete(url);
                return regularThenResponse(response, action, () => {
                    state.dispatch({ type: packagesActions.GET_PACKAGES, payload: { id: payload.projectId } });
                    state.dispatch({ type: packagesActions.IMPORT_SCRIPTS, payload: { projectId: payload.projectId } });
                });
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [packagesActions.IMPORT_SCRIPTS]: async (action: any, next: Next) => {
            try {
                const payload = action.payload;
                const response = await http.get(`${restServiceUrl}Projects/${payload.projectId}/ScanAndGetImportedScripts`);
                return regularThenResponse(response, action, (response: any) => {
                    const data = { scripts: response.data.scripts, scriptImportErrors: response.data.errorMessages };
                    next({ type: packagesActions.SET_SCRIPTS, payload: data });
                });
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [packagesActions.REORDER_SCRIPTS]: async (action: any, _: Next, state: any) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Packages/${payload.packageId}/ReOrder`;
                const response = await http.put(url, payload.ids);
                return regularThenResponse(response, action, () => {
                    state.dispatch({ type: packagesActions.GET_PACKAGES, payload: { id: payload.projectId } });
                });
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [packagesActions.SET_IS_ADHOC_FOR_PACKAGE]: async (action: any) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Packages/${payload.packageId}/IsAdhoc/${payload.isAdhocPackage}/SetIsAdhocPackage`;
                const response = await http.put(url, {});
                return regularThenResponse(response, action);
            } catch (error) {
                return regularThenResponseError(action, error);
            }
        },
        [packagesActions.SET_ENABLE_OR_DISABLE_FOR_PACKAGE]: async (action: any) => {
            try {
                const payload = action.payload;
                // const custumIsEnabled = payload.isEnabled.isEnabled ? "True" : "False"
                const url = `${restServiceUrl}Projects/${payload.projectId}/Packages/${payload.packageId}/IsEnabled/${payload.isEnabled.isEnabled}/SetIsEnabled`;
                const response = await http.put(url, {});
                return regularThenResponse(response, action);
            } catch(error) {
                return regularThenResponseError(action, error);
            }
        },
        [packagesActions.ADD_PACKAGE_EXCLUSION]: async (action: any) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Packages/${payload.packageId}/Exclusions/${payload.typeId}`;
                const response = await http.put(url, payload.isEnabled);
                return regularThenResponse(response, action);
            } catch(error) {
                return regularThenResponseError(action, error);
            }
        },
        [packagesActions.DELETE_PACKAGE_EXCLUSION]: async (action: any) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Packages/${payload.packageId}/Exclusions/${payload.typeId}`;
                const response = await http.delete(url, payload.isEnabled);
                return regularThenResponse(response, action);
            } catch (error) {
                return regularThenResponseError(action, error);
            }
        },
        [packagesActions.TEST_PACKAGE]: async (action: any, _: Next, state: any) => {
            try{
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/TestPackage/${payload.packageId}`;
                const response = await http.get(url);
                return regularThenResponse(response, action, () => {
                    state.dispatch({ type: packagesActions.GET_PACKAGES, payload: { id: action.payload.projectId } });
                });
            }
           catch{
               
           }
        },
        [packagesActions.GET_AFFECTED_OBJECTS]: async (action: any) => {
            const payload = action.payload;
            const url = `${restServiceUrl}Projects/${payload.projectId}/Packages/${payload.packageId}/AffectedObjects`;
            const response = await http.get(url);
            return response;
        },
        [packagesActions.IGNORE_SCRIPT_WARNING]: async (action: any) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Scripts/${payload.scriptId}/IgnoreScriptWarnings`;
                const response = await http({ method: 'POST', url });
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [packagesActions.PROMOTE_DEMOTE_PACKAGE]: async (action: any) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Packages/${payload.packageId}`
                    + `/${payload.action}/TargetProject/${payload.targetProjectId}`;
                const data = { targetPackageName: action.payload.targetPackage };
                const response = await http({ method: 'POST', url, data });
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [packagesActions.GET_VERSION_SUGGESTED_FOR_PROMOTIONS]: async (action: any) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/Mapping/${payload.projectId}/Version/${payload.packageId}/${payload.action}`;
                const response = await http({ method: 'GET', url });
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [packagesActions.GET_EFFECTIVE_DEPLOYED_PACKAGES]: async (action: any, next: Next) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.environmentId}`
                    + `/GetEffectiveDeployedPackages/PageNumber/${payload.pageNumber}/PageSize/${payload.pageSize}`;
                const response = await http.post(url,  payload );
                next({ type: packagesActions.SET_EFFECTIVE_DEPLOYED_PACKAGES, payload: { deployedPackages: response.data } });
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [packagesActions.GET_EFFECTIVE_DEPLOYED_PACKAGES_HISTORY]: async (action: any, next: Next) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.environmentId}`
                    + `/GetDeployedPackagesHistory/PageNumber/${payload.pageNumber}/PageSize/${payload.pageSize}`;
                const response = await http.post(url, payload);
                next({ type: packagesActions.SET_EFFECTIVE_DEPLOYED_PACKAGES_HISTORY, payload: { deployedPackages: response.data } });
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        //GetPackagesByWildcardAndLimit/{projectId}/{limit}/{filter}
        [packagesActions.GET_PACKAGES_BY_WILDCARD_AND_LIMIT]: async (action: any, next: Next) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}GetPackagesByWildcardAndLimit/${payload.projectId}/${payload.limit}/${payload.wildcard}`;
                    
                const response = await http.get(url);
                next({ type: packagesActions.SET_PACKAGES_BY_WILDCARD_AND_LIMIT, payload: { deployedPackages: response.data } });
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [packagesActions.DELETE_DEPLOYED_PACKAGE]: async (action: any, next: Next, state: any) => {
            try {
                const payload = action.payload;
                const url = `${restServiceUrl}projects/${payload.projectId}/Environments/${payload.environmentId}/DeployedPackage/${payload.packageId}`;
                const response = await http.delete(url);
                return regularThenResponse(response, action, (response: any) => {
                    if (response.data === true) {
                        const deployedPackages = state.getState().packageManager.deployedPackages;
                        next({
                            type: packagesActions.SET_EFFECTIVE_DEPLOYED_PACKAGES_HISTORY,
                            payload: {
                                deployedPackages: deployedPackages.filter((m: any) => m.id !== action.payload.packageId)
                            }
                        });
                    }
                });
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/packages.middleware.ts